import React from "react";
import { useTranslation } from "react-i18next";
import PungoSectionCard from "pungo-ui/PungoSectionCard";
import json2mq from "json2mq";
import useMediaQuery from "@mui/material/useMediaQuery";

import image01 from "assets/AucaImages/Implementation01.jpg";
import image02 from "assets/AucaImages/Implementation02.jpg";
import image03 from "assets/AucaImages/Implementation03.jpg";
import image04 from "assets/AucaImages/Implementation04.jpg";

import PungoCardTopBottom from "pungo-ui/PungoCardTopBottom";
import PungoCustomizedCarousel from "pungo-ui/PungoCustomizedCarousel";

import colors from "styles/export.module.scss";
import styles from "./index.module.scss";
import breakpoints from "styles/export.module.scss";

const ImplementationFlow = () => {
  const { t } = useTranslation();

  const desktopView = useMediaQuery(
    json2mq({
      minWidth: breakpoints.lg,
    })
  );

  const workflowSteps = [
    {
      id: "implementationFlow01",
      name: t("implementationFlow.step01.title"),
      description: t("implementationFlow.step01.text"),
      image: image01,
      color: colors.green3,
      position: "top",
      order: "01"
    },
    {
      id: "implementationFlow02",
      name: t("implementationFlow.step02.title"),
      description: t("implementationFlow.step02.text"),
      image: image02,
      color: colors.blue2,
      order: "02"
    },
    {
      id: "implementationFlow03",
      name: t("implementationFlow.step03.title"),
      description: t("implementationFlow.step03.text"),
      image: image03,
      color: colors.green3,
      position: "top",
      order: "03"
    },
    {
      id: "implementationFlow04",
      name: t("implementationFlow.step04.title"),
      description: t("implementationFlow.step04.text"),
      image: image04,
      color: colors.blue2,
      order: "04"
    },
  ];

  const getWorkflowSection = () =>
    workflowSteps.map(({ id, name, description, image, color, position, order }) => (
      <div key={id} className={styles.cardContainer}>
        <PungoCardTopBottom
          key={name}
          image={image}
          title={name}
          description={description}
          color={color}
          position={position}
          order={order}
        />
      </div>
    ));

  return (
    <PungoSectionCard
      title={t("implementationFlow.title")}
      description={""}
      id="implementationFlow"
    >
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          {desktopView ? (
            getWorkflowSection()
          ) : (
            <div className={styles.carouselContainer}>
              <PungoCustomizedCarousel
                slides={getWorkflowSection()}
                height={390}
              />
            </div>
          )}
        </div>
      </div>
    </PungoSectionCard>
  );
};

export default ImplementationFlow;
